import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-peace': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M362.1 192c42.6-13.3 85.9 19.1 85.9 64l0 70c0 4.3-0.8 11.1-1.7 15.2l-27.4 119c-7 30.4-33.8 51.8-64.6 51.8h-205.7c-23.8 0-46-13-57.7-34l-54.9-98c-19.3-34.4-5.8-67.3 24.7-92.2l-55.8-144.9c-14.6-37.9 3.7-80.6 41.2-95.6 37.6-15.1 80.4 3.6 95.1 41.9l18.7 78.8-9.1-94c0-40.8 32.8-74 73.1-74s73.1 33.2 73.1 74v87.6c26.2-3.7 51.3 8.7 65 30.3zM400 326l0-70c0-25.2-36.6-25.1-36.6 0 0 8.8-7.2 16-16 16h-6.9c-8.8 0-16-7.2-16-16v-28c0-25.2-36.6-25.1-36.6 0v28c0 8.8-7.2 16-16 16h-6.9c-8.8 0-16-7.2-16-16v-182c0-34.4-50.3-34.4-50.3 0v182c0 8.8-7.2 16-16 16h-11.6v0c-6.1 0-12.8-4.6-14.9-10.3l-59.8-155.4c-12.1-31.6-59.3-13.4-46.7 19.2l64.1 166.5c0.6 1.5 1.1 4.1 1.1 5.7 0 4.2-2.6 9.7-5.9 12.4l-26.6 21.8c-7.1 5.8-9.1 16.3-4.5 24.5l54.9 98c3.3 5.8 9.3 9.4 15.8 9.4h205.7c8.5 0 15.8-6 17.8-14.6l27.4-119c0.3-1.4 0.5-2.9 0.5-4.4z'
      }
    ]
  }
})
